/* account classes are
    Revenue,
    Expense,
    Asset,
    Equity,
    Liability

 // account types are
 None = 0,
     Bank = 1,
     Current = 2,
     CurrentLiability = 3,
     Depreciation = 4,
     DirectCosts = 5,
     Equity = 6,
     Expense = 7,
     Fixed = 8,
     Inventory = 9,
     Liability = 10,
     NonCurrent = 11,
     OtherIncome = 12,
     Overheads = 13,
     Prepayment = 14,
     Revenue = 15,
     Sales = 16,
     TermLiability = 17,
     PayGLiability = 18,
     SuperannuationExpense = 19,
     SuperannuationLiability = 20,
     WagesExpense = 21
     */

import {XeroLinkDescriptor} from "sharedFeatures/sharedModels/xero/xeroLinkDescriptor";

export enum XeroAccountMatchType {
    amPLAccounts = 1, // Profit & Loss
    amBSAccounts = 2  // Balance Sheet
}

export class XeroMatchedAccount {
    // Xero Account Code/Name/Class fields
    AccountID: string;
    AccountCode: string;
    DisplayCode: string = '';
    AccountName: string;
    DisplayName: string = '';
    AccountClass: string;
    AccountType: number;
    BankAccountType: number;
    IsHidden: boolean = false;

    // Xero account heading according to P&L or BS screens headings
    AccountHeading: string;

    // Xero account subheading
    AccountSubHeading: string;

    // Profit & Loss (or Balance Sheet) values imported from Trial Balance report
    // PL/BS type is defined by MatchType field
    PLValues?: Array<number>;

    // CashFlow values imported from bank transactions
    CFValues?: Array<number>;

    // Xero account Tax type
    TaxType: string;

    // 1 = PL, 2 = BS
    MatchType: number;

    // Xero links (dropdowns) properties
    // used only on Imprort Screens stage
    matchedXeroLinks: Array<XeroLinkDescriptor>;

    // zero-based PL/BS values
    _PLValueZ: Array<number> | undefined;

    get PLValueZ(): Array<number> {
        let result: Array<number> = new Array<number>();

        if (this.PLValues != null) {
            for (let val of this.PLValues)
                result.push(val !== null ? val : 0);
        }

        return result;
    }

    _CFValueZ: Array<number> | undefined;

    get CFValueZ(): Array<number> {
        let result: Array<number> = new Array<number>();

        if (this.CFValues != null) {
            for (let val of this.CFValues)
                result.push(val !== null ? val : 0);
        }

        return result;
    }


    constructor() {
        this.AccountID = '';
        this.AccountCode = '';
        this.AccountName = '';
        this.AccountClass = '';
        this.AccountType = 0;
        this.BankAccountType = 0;

        // Xero account heading according to P&L or BS screens headings
        this.AccountHeading = '';

        // Xero account subheading
        this.AccountSubHeading = '';

        // Profit & Loss (or Balance Sheet) values imported from Trial Balance report
        // PL/BS type is defined by MatchType field
        this.PLValues = undefined;

        // CashFlow values imported from bank transactions
        this.CFValues = undefined;

        // Xero account Tax type
        this.TaxType = '';

        // 1 = PL, 2 = BS
        this.MatchType = 0;

        // Xero links (dropdowns) properties
        // used only on Imprort Screens stage
        this.matchedXeroLinks = Array<XeroLinkDescriptor>();
    }

}

// Class describing Xero account on import and create object stage
export class XeroImportedAccount extends XeroMatchedAccount
{
    // Actual account tax rate
    TaxRate: number;

    // Skip object creation according to user decision
    isBlankObject: boolean;

    // Is object already imported service field
    isObjectImported: boolean;

    // Corresponding Brixx record id / reserved for future use
    objectNodeID: number;

    // Corresponding Brixx record id / reserved for future use
    objectPropertyID: string;

    // Xero links (dropdowns) properties
    // Used on components creation stage in balancer
    importedXeroLinks: Array<XeroLinkDescriptor>;


    constructor() {
        super();
        this.TaxRate = 0;
        this.isBlankObject = false;
        this.isObjectImported = false;
        this.objectNodeID = 0;
        this.objectPropertyID = '';
        this.importedXeroLinks = [];
    }
}
